import { Component, Input } from '@angular/core';
import { PaymentService } from '../../../common/service/payment.service';

@Component({
  selector: 'complete-component',
  templateUrl: './complete.component.html',
})
export class FormCompleteComponent {
  @Input() dismiss;
  widgetType: string;

  constructor(protected paymentService: PaymentService) {
    this.widgetType = this.paymentService.getChannelName();
  }

  cancel() {
    this.paymentService.reset();
    this.dismiss();
  }
}
